import { render, staticRenderFns } from "./AboutImprimBook.vue?vue&type=template&id=403981d0&scoped=true&"
import script from "./AboutImprimBook.vue?vue&type=script&lang=js&"
export * from "./AboutImprimBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403981d0",
  null
  
)

export default component.exports